/**
 * Story modal — the "Příběh zakázky" long read behind each before/after example.
 *
 * Uses a native <dialog>, so focus trapping, Esc and the backdrop come from the platform
 * rather than from us. The only things worth wiring by hand are the openers, the close
 * buttons, and a click on the backdrop itself.
 */
export function storyModal() {
  const openers = document.querySelectorAll('[data-story-open]');
  if (!openers.length) return;

  openers.forEach((btn) => {
    const dialog = document.getElementById(btn.dataset.storyOpen);
    if (!dialog) return;
    btn.addEventListener('click', () => {
      // showModal() is what gives the backdrop and the focus trap; the attribute
      // fallback still shows the content on anything that lacks it.
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('dialog.system-story').forEach((dialog) => {
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };
    dialog.querySelectorAll('[data-story-close]').forEach((btn) => {
      // The CTA inside also carries data-story-close: it navigates to an anchor on the
      // same page, which an open modal would otherwise sit on top of.
      btn.addEventListener('click', close);
    });
    // A click that lands on the dialog element itself is a click on the backdrop —
    // anything inside the content wrapper stops there.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
    });
  });
}
